import styled from 'styled-components';
import { fromLarge } from 'styleUtils/mediaQueries';
import { gridRow, gridColumn, GridStartEndAttributes } from 'styleUtils/grid';
import { GridItem } from './GridItem';

const defaultImageColumn: GridStartEndAttributes = { start: 1, end: 3 };
const meetRightImageColumn: GridStartEndAttributes = { start: 2, end: 4 };

export const ImageWrapper = styled.div<GridItem>`
    ${gridRow({ start: 1, end: 3 })}
    ${({ meetRight }): string => {
        return gridColumn(meetRight ? meetRightImageColumn : defaultImageColumn);
    }}

    z-index: 1;
    display: none;

    ${fromLarge`
        display: block;
  `};
`;
